import React from "react";
import { Box } from '@mui/joy';
import { Pie } from 'src/mtska-frontend-app-component';

const PieTraceKM = ({ user, filters, createSliceFilterHandler, handleFilterChange, t }) => {
    return (
        <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Tutte i rilevamenti")}<br></br>{t("kilometrici")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_general/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Rilevamento KM")}<br></br>{t("Clienti VIP")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_vip/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "VIP (OVER 50)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Rilevamento KM")}<br></br>{t("Clienti TOP")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_top/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "TOP (21-50)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Rilevamento KM")}<br></br>{t("Clienti MEDIUM")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_medium/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "MEDIUM (6-20)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Rilevamento KM")}<br></br>{t("Clienti SMALL")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_small/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "SMALL (2-5)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={<>{t("Rilevamento KM")}<br></br>{t("Clienti SINGLE")}</>}
                    dataProviderName={"statisticsviews/fleetbykm_single/aggregated/views_cars_car/traceKmsCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || []),
                            {
                                field: "_related_legalEntity_commercialCluster",
                                operator: "equals",
                                value: "SINGLE (1)"
                            }
                        ]
                    }}
                    monochrome={{
                        enabled: true,
                        color: '#52b5f1',
                        shadeTo: 'dark',
                        shadeIntensity: 1
                    }}
                    height={180}
                    donutWidth={220}
                    legendPosition='bottom'
                //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                />
            </Box>
        </Box>
    )
}

export default PieTraceKM